import type {ReactNode, MouseEvent} from 'react';
import React from 'react';
import classNames from 'classnames';

import {TypographySize, useTypography} from '../../../hooks/typography';

import styles from './styles.module.css';

export type MenuItemActionProps = {
    icon?: ReactNode;
    name?: string;
    onClick?: (e: MouseEvent) => void;
    additionalContent?: ReactNode;
    description?: string;
    className?: string;
}

export const MenuItemAction = React.forwardRef<HTMLLIElement, MenuItemActionProps>((props, ref) => {
    const [bodyLCls, bodySCls] = useTypography([{
        size: TypographySize.BodyL,
    }, {
        size: TypographySize.BodyS,
        noDefaultColor: true,
    }]);

    const icon = props.icon ? <div className={styles.icon}>{props.icon}</div> : null;
    const name = props.name ? <div className={classNames(bodyLCls, styles.name)}>{props.name}</div> : null;
    const additionalContent = props.additionalContent ? (
        <div className={styles.additionalContent}>{props.additionalContent}</div>
    ) : null;

    const className = classNames(styles.menuItem, props.className);

    return (
        <li ref={ref} className={className} onClick={props.onClick}>
            <div className={styles.line}>
                {icon}
                {name}
                {additionalContent}
            </div>
            {props.description && (
                <div className={classNames(styles.line, styles.description, bodySCls)}>
                    {props.description}
                </div>
            )}
        </li>
    );
});
